var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "breadcrumbs" },
    _vm._l(_vm.levelList, function (item, index) {
      return _c("li", { key: item.path }, [
        item.redirect === "noRedirect" || index == _vm.levelList.length - 1
          ? _c("span", { staticClass: "no-redirect" }, [
              _vm._v(_vm._s(item.meta.title)),
            ])
          : _c(
              "a",
              {
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.handleLink(item)
                  },
                },
              },
              [
                _vm._v(_vm._s(item.meta.title)),
                _c("span", { staticClass: "breadcrumb-route" }, [_vm._v("/")]),
              ]
            ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }